import type {ReactElement} from 'react';
import {AiGenerationPopover} from '@Components/ai-generation-popover';
import AiGenerationPanel from '@Panels/ai-generation-panel/ai-generation-panel';
import type {AiWriterProps} from './ai-writer.types';
import {AiWriterType} from '@Components/ai-writer/ai-writer.types';

export function AiWriter<T>({
  displayType,
  source,
  className,
  closeOnItemSelect,
  showBackButton,
  onBack,
  onClose,
  isOpenedInPopOver,
  alignment,
  referenceElementRef,
  isOpen,
}: AiWriterProps<T>): ReactElement {
  if (displayType === AiWriterType.POPOVER) {
    return (
      <AiGenerationPopover<T>
        {...source}
        className={className}
        closePopoverOnItemSelect={closeOnItemSelect}
        alignment={alignment}
        referenceElementRef={referenceElementRef}
        isOpen={isOpen}
        onClose={onClose}
      />
    );
  }

  return (
    <AiGenerationPanel<T>
      {...source}
      closeOnItemSelect={closeOnItemSelect}
      showBackButton={showBackButton}
      onBack={onBack}
      onClose={onClose}
      isOpenedInPopOver={isOpenedInPopOver}
    />
  );
}
